import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardService } from 'services/dashboardService';
import { parseApiError } from 'utils/errorParser';

export const fetchDashboard = createAsyncThunk('dashboard/fetch', async (_, { rejectWithValue }) => {
  try {
    const [summary, charts, activities, pendingActions] = await Promise.all([
      dashboardService.getSummary(),
      dashboardService.getCharts(),
      dashboardService.getActivities(10),
      dashboardService.getPendingActions(),
    ]);
    return { summary, charts, activities, pendingActions };
  } catch (error) {
    return rejectWithValue(parseApiError(error));
  }
});

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    summary: null,
    charts: null,
    activities: [],
    pendingActions: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboard.pending, (state) => { state.status = 'loading'; })
      .addCase(fetchDashboard.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.summary = action.payload.summary;
        state.charts = action.payload.charts;
        state.activities = action.payload.activities;
        state.pendingActions = action.payload.pendingActions;
      })
      .addCase(fetchDashboard.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.message;
      });
  },
});

export default dashboardSlice.reducer;
